import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/admin/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      if (err.response?.status === 422) {
        setError("Format d'email invalide.");
      } else if (!err.response) {
        setError("Impossible de contacter le serveur. Vérifie ta connexion.");
      } else {
        setError("Une erreur est survenue. Réessaie dans un instant.");
      }
    } finally { setLoading(false); }
  }

  return (
    <div data-testid="admin-forgot-page" className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-[#F5F0E6] p-10 border border-[#E8DCC8]">
        <p className="font-hand text-2xl text-[#A3876A] mb-2">Back-office</p>
        <h1 className="font-serif text-4xl mb-4">Mot de passe oublié</h1>

        {sent ? (
          <div data-testid="admin-forgot-sent" className="mt-6">
            <div className="flex items-start gap-3 bg-[#EEF3EA] border border-[#C7D3BE] text-[#4C5F3F] px-4 py-4 text-sm leading-relaxed">
              <CheckCircle2 size={20} className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium mb-1">Vérifie tes emails</p>
                <p>Si <strong>{email}</strong> correspond à un compte, tu recevras un lien de réinitialisation d'ici quelques minutes. Il est valable 1 heure.</p>
              </div>
            </div>
            <p className="text-xs text-[#7C7064] mt-4">
              Pas d'email ? Regarde dans tes indésirables ou{" "}
              <button
                onClick={() => { setSent(false); setError(""); }}
                className="underline underline-offset-4 hover:text-[#A3876A]"
              >
                réessaie
              </button>.
            </p>
            <div className="mt-8 pt-6 border-t border-[#E8DCC8] text-center">
              <Link to="/admin/login" className="text-sm text-[#A3876A] hover:text-[#8A7158] underline underline-offset-4">
                ← Retour à la connexion
              </Link>
            </div>
          </div>
        ) : (
          <>
            <p className="text-sm text-[#4A4036] leading-relaxed mb-6">
              Renseigne ton email : je t'enverrai un lien pour choisir un nouveau mot de passe.
            </p>
            {error && (
              <div
                data-testid="admin-forgot-error"
                role="alert"
                className="flex items-start gap-3 bg-[#FBEBE8] border border-[#E4B8AF] text-[#8A3A2B] px-4 py-3 mb-6 text-sm leading-relaxed"
              >
                <AlertCircle size={18} className="flex-shrink-0 mt-0.5" />
                <span>{error}</span>
              </div>
            )}
            <form onSubmit={submit} className="space-y-6">
              <input
                data-testid="admin-forgot-email"
                className="field-input"
                type="email"
                placeholder="Ton email"
                required
                value={email}
                onChange={e => { setEmail(e.target.value); if (error) setError(""); }}
                autoComplete="email"
                autoFocus
              />
              <button
                data-testid="admin-forgot-submit"
                type="submit"
                disabled={loading}
                className="btn-primary w-full justify-center"
              >
                {loading ? "…" : "Recevoir le lien"}
              </button>
            </form>
            <div className="mt-6 text-center">
              <Link to="/admin/login" className="text-sm text-[#A3876A] hover:text-[#8A7158] underline underline-offset-4">
                ← Retour à la connexion
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
